<script>
import { computed } from 'vue';

import Color from './Legend/Color.vue';
import DotSize from './Legend/DotSize.vue';
import PercentBar from './Legend/PercentBar.vue';

import formatValue from '@/utils/formatValue';
import useSectionState from '@/state/useSectionState';

export default {
  components: {
    Color,
    DotSize,
    PercentBar,
  },
  props: {
    minNegRange: {
      type: Number,
      default: 0,
    },
    maxNegRange: {
      type: Number,
      default: 0,
    },
    minPosRange: {
      type: Number,
      default: 0,
    },
    maxPosRange: {
      type: Number,
      default: 0,
    },
    minSizeRange: {
      type: Number,
      default: 0,
    },
    maxSizeRange: {
      type: Number,
      default: 0,
    },
    themeFirst: {
      type: String,
      default: '',
    },
    themeSecond: {
      type: String,
      default: '',
    },
    format: {
      type: String,
      default: '',
    },
    measureText: {
      type: String,
      default: '',
    },
  },
  setup(props) {
    const formattedMinSizeRange = computed(() => formatValue(props.minSizeRange, props.format));
    const formattedMaxSizeRange = computed(() => formatValue(props.maxSizeRange, props.format));

    const { sectionName } = useSectionState();

    const captions = ['Underperforming', 'Overperforming'];

    const currentCaptions = computed(() => (sectionName.value === 'disparities'
      ? [...captions].reverse()
      : captions));

    return {
      formattedMinSizeRange,
      formattedMaxSizeRange,
      currentCaptions,
    };
  },
};
</script>

<template>
  <div class="flex flex-wrap items-center justify-center my-8 xl:gap-x-16 bg-base-100">
    <Color>
      <template #legend>
        <PercentBar
          v-if="minNegRange || maxNegRange"
          :min-range="maxNegRange"
          :max-range="minNegRange"
          :theme="themeSecond"
          inverse
          :caption="$t(currentCaptions[0])"
        />
        <PercentBar
          v-if="minPosRange || maxPosRange"
          :min-range="minPosRange"
          :max-range="maxPosRange"
          :theme="themeFirst"
          :caption="$t(currentCaptions[1])"
        />
      </template>
    </Color>
    <DotSize
      :min-size-range="formattedMinSizeRange"
      :max-size-range="formattedMaxSizeRange"
    >
      <template #measure-text>
        {{ measureText }}
      </template>
    </DotSize>
  </div>
</template>
